
const lambdaConfig = {
    accessKey: "AKIAY4ITU535DTWKOMLY",
    secretKey: "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",
    region: "us-west-2"
};

export default lambdaConfig;